import {DefaultService} from "./DefaultService";

class ParametersFilterService extends DefaultService {
    getParametersFilter(params){
        return this.post('/customer/parameters-filter', params).then(res => res.data)
    }
}

export default ParametersFilterService;